import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { dashBoardReportAction, dashBoardReportRegisteredUsersAction, dashBoardReportWorkOutSessionsAction } from "../../Redux/Actions/DashboardReportAction";
import { secondsToHHMMSS, sumOfRecordCounts, sumOfRecordCountsWithoutDecimal } from "../../helper/utility";
import { Constants } from "../Common/Constants";
import AreaGraphMonthly from "../Common/Graphs/AreaGraphMonthyl";


dayjs.extend(utc);
dayjs.extend(timezone);

const Quarterly = () => {
  // const { dashboardData } = useSelector((store) => store.Dashboard);

  const { male, female, total } = useSelector((store) => store.dashBoardReportReducer.activeUsers);
  const uniqueActiveUsersMale = useSelector((store) => store.dashBoardReportReducer.activeUsers.uniqueActiveUsers.male);
  const uniqueActiveUsersFemale = useSelector((store) => store.dashBoardReportReducer.activeUsers.uniqueActiveUsers.female);
  const registeredUsers = useSelector((s) => s.dashBoardReportReducer.registeredUsers);
  const workOutSessions = useSelector((store) => store.dashBoardReportReducer.workOutSessions);
  const totalDuration = useSelector((store) => store.dashBoardReportReducer.totalDuration);

  const sumOfRegisteredUsers = sumOfRecordCountsWithoutDecimal(registeredUsers);
  const sumOfWorkoutSessions = sumOfRecordCountsWithoutDecimal(workOutSessions);
  const sumOfTotalDuration = sumOfRecordCounts(totalDuration);
  // const sumOfMale = sumOfRecordCounts(male);
  // const sumOfFemale = sumOfRecordCounts(female);
  // const sumOfTotal = sumOfRecordCounts(total);

  const dispatch = useDispatch();
  useEffect(function () {
    const today = new Date();

    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const tz = dayjs.tz.guess();

    const formattedDate = tomorrow.toISOString().split("T")[0];

    dispatch(dashBoardReportAction({ noOfDays: 90, currentDate: formattedDate, tz }));
    dispatch(dashBoardReportRegisteredUsersAction({ noOfDays: 90, currentDate: formattedDate, tz }));
    dispatch(dashBoardReportWorkOutSessionsAction({ noOfDays: 90, currentDate: formattedDate, tz }));
  }, []);


  return (
    <div className="row mt-4">
      <div id="chart" className="col-md-4">
        <AreaGraphMonthly
          // data={dashboardData?.registeredUserQuater}
          data={registeredUsers}
          // title={Constants.totalRegisteredUsers}
          title={`${Constants.totalRegisteredUsers} ${sumOfRegisteredUsers}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <AreaGraphMonthly
          // data={dashboardData?.totalActiveUserQuater}
          data={total}
          // title={Constants.totalActiveUsers}
          title={`${Constants.totalActiveUsers} ${uniqueActiveUsersMale ? uniqueActiveUsersMale + uniqueActiveUsersFemale : 0}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <AreaGraphMonthly
          // data={dashboardData?.activeMaleUsersQuater}
          data={male}
          // title={Constants.totalActiveUsersMale}
          title={`${Constants.totalActiveUsersMale} ${uniqueActiveUsersMale || 0}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <AreaGraphMonthly
          // data={dashboardData?.activeFeMaleUsersQuater}
          data={female}
          // title={Constants.totalActiveUsersFemale}
          title={`${Constants.totalActiveUsersFemale} ${uniqueActiveUsersMale ? uniqueActiveUsersFemale : 0}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <AreaGraphMonthly
          // data={dashboardData?.lastqauterWorkoutSession}
          data={workOutSessions}
          // title={Constants.totalWorkoutSessions}
          title={`${Constants.totalWorkoutSessions} ${sumOfWorkoutSessions}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <AreaGraphMonthly
          // data={dashboardData?.avgWorkoutDurationQuaterly}
          data={totalDuration}
          // title={Constants.totalWorkoutSessionDuration}
          title={`${Constants.totalWorkoutSessionDuration} ${secondsToHHMMSS(sumOfTotalDuration)}`}
          format=""
          yAxisType={"time"}
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default Quarterly;
